<template>
  <div class="text-center">
    <b-badge v-if="value"
    class="w-75 size"
    :variant="sizeIndicator(value)"
    >{{ formatBytes(value) }}
    </b-badge>
    <span v-else>N/A</span>
  </div>
</template>

<script>
import lmFormatBytes from '@/mixins/lmFormatBytes.js'

export default {
  mixins: [lmFormatBytes],
  props: {
    value: {
      type: [Number, String],
      required: true
    }
  },
  computed: {
  }
}
</script>

<style lang="sass" scoped>
.size
  min-width: 70px
</style>
